import { all } from "redux-saga/effects";
import { watchSetCustomerName } from "./home/saga";
import {
  watchGetDriverCitationStates,
  watchGetDriverCreditCardValue,
  watchExternalCitationPaymentSaga
} from "./citation/saga";
import {
  watchGetCustomerDashboardWithoutSession,
  watchGetCustomerDashboardWithSession,
  watchGetCustomerDashboardWithSessionShibboleth,
  watchGetCustomerDashboardWithSessionAccountIdentifier,
  watchGetCustomerDashboardEmailVerification,
} from "./dashboard/saga";
import {
  watchGetCustomerRegisterWithoutSession,
  watchGetCustomerRegisterWithSession,
} from "./register/saga";
import { watchGetDriverViewOrderStates } from "./vieworder/saga";
import { watchGetDriverPermitListStates, watchGetDriverVirtualPermitResion } from "./permitList/saga";
import {
  watchGetDriverCitationPDFStates,
  watchGetDriverCitationPDFStatesUnpaid,
} from "./citationDetailPDF/saga";
import {
  watchForgetPassword,
  watchForgetuserName,
  watchGetCitationEnabled,
  watchGetCitationAppealsPreferences,
  watchGetUserContext,
  watchGetVerifyEmail,
  // watchHomeLogin,
  watchLogin,
  watchKeycloakLogin,
  watchLogOut,
  watchRegister,
  watchResetPassword,
  watchUnsetPath,
} from "./login/saga";
import { watchGetAmericanStates } from "./pay-citation/saga";
import {
  watchCreateProfileAddress,
  watchCreateProfileBillingAddress,
  watchCreateProfileEmail,
  watchGetProfileStates,
  watchCreateProfilePhone,
  watchCreateProfileEditVehicle,
  watchCreateProfileEditAddress,
  watchCreateProfileEditEmail,
  watchCreateProfileEditPhone,
  watchGetDriverVehicleMakeStates,
  watchCreateProfileEditDOB,
  watchProfileDriverStyling,
  watchCreateProfileVehicle,
  watchProfileDeleteEditAddress,
  watchProfileDeleteVehicle,
  watchcallGetProfileVehicleDetails,
  watchcallGetProfileVehicleActivateDeactivate,
  watchProfileUpdatePassword,
  watchcallGetProfileEmailDetails,
  watchcallGetProfileEmailActivateDeactivate,
  watchcallGetProfileAddressDetails,
  watchcallGetProfileAddressActivateDeactivate,
  watchcallGetProfilePhoneDetails,
  watchcallGetProfilePhoneActivateDeactivate,
  watchGetStates,
  watchGetMyAccountEditorDataStates,
  watchGetReviewAndOrderEditorDataStates,
  watchGetPaymentPageEditorDataStates,
  watchGetCheckboxAgreementTextEditorDataStates,
  watchGetOrderCompletePageEditorDataStates,
  watchGetCitationInformationEditorDataStates,
  watchGetTermsOfUsesEditorDataStates,
  watchGetCitationDetailsPageEditorDataStates,
  watchGetNewOrderPermitDataStates,
  watchGetPaymentTextCitationEditorDataStates,
  watchGetPaymentAcceptedTextCitationEditorDataStates,
  watchGetAppealFineHeaderEditorDataStates,
  watchcallGetAccountVehicleDetails,
} from "./profile/saga";
import {
  watchCitationDetail,
  watchPayCitationDetail,
  whatchCitationAppeal,
  whatchCitationReplyAppeal,
} from "./citationDetail/saga";
import {
  watchcallBuyPermitOrderPayment,
  watchCallBuyPermitPaymentMethods,
  watchcallCheckoutAddressModalDetails,
  watchcallCheckoutEmailModalDetails,
  watchcallCheckoutPhoneModalDetails,
  watchCallBuyPermitGetPermitNumber,
  watchCallCreateCardVerification,
  watchCallTaxRateVerification,
  watchcallBuyUpdateVehicleListPermit,
  watchCallResumeBuyPermitOrderPayment,
} from "./buyPermits/saga";
import { watchGetDriverOrderPDFStates } from "./orderDetailPDF/saga";
import { watchRequiredFields } from "./ProfileRequiredField/saga";
import { watchGetAddPermitText } from "./addPermitText/saga";
import { watchVehicleRequiredFields } from "./vehicleRequiredField/saga";
import {
  watchGetcallGetVisitorPermitList,
  watchGetGetVisitorPermitCardType,
  watchVisitorPermit,
  watchGetPdfVisitorPermit
} from "./visitorPermit/saga";
import { watchSystemAlert } from "./systemAlert/saga";
export default function* rootSaga() {
  yield all([
    /************ Login **********************/
    watchLogin(),
    watchKeycloakLogin(),
    // watchHomeLogin(),
    watchRegister(),
    watchLogOut(),
    watchUnsetPath(),
    watchForgetPassword(),
    watchForgetuserName(),
    watchResetPassword(),
    /***********   Home  *********************/
    watchSetCustomerName(),
    watchGetUserContext(),

    /**********  pay-cittation   **********/
    watchGetAmericanStates(),
    watchExternalCitationPaymentSaga(),

    /****************  Profile    ********************* */
    watchGetProfileStates(),
    watchProfileDeleteVehicle(),
    watchCreateProfileEmail(),
    watchCreateProfileAddress(),
    watchCreateProfileBillingAddress(),
    watchCreateProfilePhone(),
    watchCreateProfileEditVehicle(),
    watchCreateProfileEditEmail(),
    watchCreateProfileEditAddress(),
    watchCreateProfileEditDOB(),
    watchCreateProfileEditPhone(),
    watchGetDriverVehicleMakeStates(),
    watchProfileDriverStyling(),
    watchCreateProfileVehicle(),
    watchProfileDeleteEditAddress(),
    watchcallGetProfileVehicleDetails(),
    watchcallGetProfileVehicleActivateDeactivate(),
    watchProfileUpdatePassword(),
    watchRequiredFields(),
    watchVehicleRequiredFields(),
    watchGetMyAccountEditorDataStates(),
    watchGetReviewAndOrderEditorDataStates(),
    watchGetPaymentPageEditorDataStates(),
    watchGetCheckboxAgreementTextEditorDataStates(),
    watchGetOrderCompletePageEditorDataStates(),
    watchGetCitationInformationEditorDataStates(),
    watchGetCitationDetailsPageEditorDataStates(),
    watchGetNewOrderPermitDataStates(),
    watchGetPaymentTextCitationEditorDataStates(),
    watchGetPaymentAcceptedTextCitationEditorDataStates(),
    watchGetAppealFineHeaderEditorDataStates(),
    watchcallGetAccountVehicleDetails(),
    watchGetTermsOfUsesEditorDataStates(),

    watchcallGetProfileEmailDetails(),
    watchcallGetProfileEmailActivateDeactivate(),
    watchcallGetProfileAddressDetails(),
    watchcallGetProfileAddressActivateDeactivate(),
    watchcallGetProfilePhoneDetails(),
    watchcallGetProfilePhoneActivateDeactivate(),
    //citation details
    watchCitationDetail(),
    watchGetDriverCitationStates(),
    watchGetDriverCreditCardValue(),
    whatchCitationAppeal(),
    whatchCitationReplyAppeal(),
    //dashboard
    watchGetCustomerDashboardWithoutSession(),
    watchGetCustomerDashboardWithSession(),
    watchGetCustomerDashboardWithSessionShibboleth(),
    watchGetCustomerDashboardWithSessionAccountIdentifier(),
    watchGetCustomerDashboardEmailVerification(),
    watchGetStates(),
    watchPayCitationDetail(),
    //register
    watchGetCustomerRegisterWithoutSession(),
    watchGetCustomerRegisterWithSession(),
    watchGetDriverViewOrderStates(),
    watchcallCheckoutAddressModalDetails(),
    watchGetDriverPermitListStates(),
    watchGetDriverVirtualPermitResion(),
    //ciationpdf
    watchGetDriverCitationPDFStates(),
    watchcallCheckoutPhoneModalDetails(),
    watchcallCheckoutEmailModalDetails(),
    watchGetDriverOrderPDFStates(),
    watchcallBuyPermitOrderPayment(),
    watchCallBuyPermitPaymentMethods(),
    watchCallBuyPermitGetPermitNumber(),
    watchCallCreateCardVerification(),
    watchCallTaxRateVerification(),
    watchcallBuyUpdateVehicleListPermit(),
    watchCallResumeBuyPermitOrderPayment(),
    watchGetAddPermitText(),
    watchGetVerifyEmail(),
    watchGetDriverCitationPDFStatesUnpaid(),
    watchGetcallGetVisitorPermitList(),
    watchVisitorPermit(),
    watchGetPdfVisitorPermit(),
    watchGetGetVisitorPermitCardType(),
    watchGetCitationEnabled(),
    watchGetCitationAppealsPreferences(),
    watchSystemAlert(),
  ]);
}
